import { render, staticRenderFns } from "./ReviewCardReply.vue?vue&type=template&id=d0907594&scoped=true&"
import script from "./ReviewCardReply.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCardReply.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewCardReply.vue?vue&type=style&index=0&id=d0907594&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0907594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0907594')) {
      api.createRecord('d0907594', component.options)
    } else {
      api.reload('d0907594', component.options)
    }
    module.hot.accept("./ReviewCardReply.vue?vue&type=template&id=d0907594&scoped=true&", function () {
      api.rerender('d0907594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardReply.vue"
export default component.exports